import React from "react";
import { LicenseWarningIcon } from "@rl-appliances/component-library";
import tcbase from "../../../shim/tcbase";
import useLocalLicense from "../hooks/useLocalLicense";

// Read consts live (not destructured at module scope) since
// window.tcbase.consts may be populated after this module first evaluates.
const isAirGappedMode = () => {
  const { cloud_enabled, t1000_enabled } = tcbase?.consts || {};
  return Boolean(t1000_enabled) && !cloud_enabled;
};

const LicenseWarning = () => {
  const { localLicense, isLocalLicenseExpiring, isLocalLicenseValidOrOnline } =
    useLocalLicense();

  // The local (offline) license is expiring soon -- this is unrelated to
  // cloud connectivity, so don't mention Spectra Intelligence when the
  // deployment doesn't use it at all (T1000-only/air-gapped).
  const message = isAirGappedMode()
    ? `License is expiring. Valid until: ${localLicense?.expiryDate ?? "-"}`
    : `Spectra Intelligence is not available or license is expiring. Valid until: ${
        localLicense?.expiryDate ?? "-"
      }`;

  return isLocalLicenseExpiring && isLocalLicenseValidOrOnline ? (
    <div className={"licensing-warning-icon-container"}>
      <LicenseWarningIcon statusMessage={message} tooltipPlacement="bottom" />
    </div>
  ) : null;
};

export default LicenseWarning;
